<template>
  <div id="new-lo-title-create">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Premium Header Card -->
    <v-container class="px-4 py-6">
      <v-card elevation="24" class="premium-header-card mb-6 overflow-hidden" style="min-height: 150px;">
        <div class="header-gradient-bg">
          <div class="header-backdrop-effect"></div>
          <div class="header-content-premium pa-8">
            <v-row align="center">
              <v-col cols="auto">
                <div class="header-icon-box">
                  <v-icon size="48" color="white">mdi-file-document-edit-outline</v-icon>
                </div>
              </v-col>
              <v-col>
                <h1 class="header-title white--text">
                  <v-progress-linear
                    v-if="LoadingFlag"
                    indeterminate
                    color="white"
                    style="max-width: 400px"
                  ></v-progress-linear>
                  <span v-else>{{ PageTitle }}</span>
                </h1>
                <p class="header-subtitle white--text">
                  {{ LoadingFlag ? "Loading form details..." : PageDescription }}
                </p>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  @click.prevent="backPage"
                  icon
                  large
                  class="premium-action-btn"
                  color="white"
                  title="Go Back"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn
                  @click.prevent="refreshPageData"
                  icon
                  large
                  class="premium-action-btn"
                  color="white"
                  :loading="LoadingFlag"
                  title="Refresh"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-container>
    <v-container class="py-0 px-4">
      <v-card class="main-card">
        <v-card-text class="content-section">
          <v-form ref="form2" v-model="valid" lazy-validation>
            <v-card elevation="3" outlined class="member-card">
              <v-card-title class="primary--text font-weight-bold">
                <v-icon color="primary" class="mr-2">mdi-account-circle</v-icon>
                <span>Member Details</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-container class="pa-6">
                <v-row wrap class="mb-4">
                  <!-- Profile Section -->
                  <v-col
                    cols="12"
                    sm="12"
                    md="3"
                    class="d-flex flex-column align-center"
                  >
                    <div class="text-center">
                      <v-img
                        :src="Member.MemberImagePath"
                        :alt="Member.MemberName"
                        lazy-src="/no-image-available.png"
                        max-width="140"
                        max-height="140"
                        class="profile-image"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <div class="mt-3">
                        <div
                          class="member-name font-weight-bold text-h6 primary--text"
                        >
                          {{ Member.MemberName }}
                        </div>
                        <div class="member-id text-caption grey--text">
                          ID: {{ Member.MembershipId }}
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <!-- Personal Info Section -->
                  <v-col cols="12" sm="12" md="3">
                    <div class="section-title font-weight-bold mb-3">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-information</v-icon
                      >
                      Personal Info
                    </div>
                    <div class="info-row">
                      <span class="info-label">Gender:</span>
                      <span class="info-value">{{ Member.GenderTxt }}</span>
                    </div>
                    <div class="info-row">
                      <span class="info-label">DOB:</span>
                      <span class="info-value">{{
                        formatDate(Member.DOB)
                      }}</span>
                    </div>

                    <div class="info-row">
                      <span class="info-label">Status:</span>
                      <v-chip
                        small
                        :color="
                          Member.UserActiveStatus == 1 ? 'success' : 'error'
                        "
                        text-color="white"
                        class="mt-1"
                      >
                        {{ Member.UserActiveStatusTxt }}
                      </v-chip>
                    </div>
                  </v-col>

                  <!-- Organization Info Section -->
                  <v-col cols="12" sm="12" md="3">
                    <div class="section-title font-weight-bold mb-3">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-building</v-icon
                      >
                      Organization
                    </div>
                    <div class="info-row">
                      <span class="info-label">LO:</span>
                      <span class="info-value font-weight-bold">{{
                        Member.LomName
                      }}</span>
                    </div>
                    <div class="info-row">
                      <span class="info-label">Zone:</span>
                      <span class="info-value">{{ Member.ZoneName }}</span>
                    </div>
                    <div class="info-row">
                      <span class="info-label">Designation:</span>
                      <v-chip
                        small
                        color="primary"
                        text-color="white"
                        class="mt-1"
                      >
                        {{ Member.Designation }}
                      </v-chip>
                    </div>
                  </v-col>

                  <!-- Contact Section -->
                  <v-col cols="12" sm="12" md="3">
                    <div class="section-title font-weight-bold mb-3">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-phone</v-icon
                      >
                      Contact
                    </div>

                    <div class="info-row">
                      <span class="info-label">Mobile:</span>
                      <span class="info-value">{{ Member.PrimaryMobile }}</span>
                    </div>

                    <div class="info-row">
                      <span class="info-label">Email:</span>
                      <span class="info-value">{{ Member.EmailId }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br /><br />

            <v-card elevation="3" outlined class="location-card">
              <div class="location-header">
                <v-icon color="white" class="header-icon-location">mdi-map-marker-radius</v-icon>
                <h3 class="location-title">Location of New LO</h3>
              </div>
              <v-container class="location-content-wrapper">
                <v-row class="location-grid" wrap>
                  <v-col cols="12" sm="12" md="6" class="location-left-col">
                   

                    <div class="form-group">
                      <label class="form-label">
                        <span class="required-mark">*</span>State
                      </label>
                      <v-autocomplete
                        @change="getDistrictCodeOptions"
                        :reduce="(option) => option.value"
                        :loading="StateCodeOptionsLoading"
                        :items="StateCodeOptions"
                        :rules="StateCodeRules"
                        v-model="StateCode"
                        required
                        outlined
                        dense
                        class="premium-input"
                        prepend-inner-icon="mdi-state"
                        background-color="white"
                      ></v-autocomplete>
                    </div>
                  </v-col>
                    <div class="form-group">
                      <label class="form-label">
                        <span class="required-mark">*</span>District
                      </label>
                      <v-autocomplete
                        @change="getCityCodeOptions"
                        :reduce="(option) => option.value"
                        :loading="DistrictCodeOptionsLoading"
                        :items="DistrictCodeOptions"
                        :rules="DistrictCodeRules"
                        v-model="DistrictCode"
                        required
                        outlined
                        dense
                        class="premium-input"
                        prepend-inner-icon="mdi-city-variant"
                        background-color="white"
                      ></v-autocomplete>
                    </div>
                    <div class="form-group">
                      <label class="form-label">
                        <span class="required-mark">*</span>City
                        <small class="form-hint">(Note – City will be prefix for all title application)</small>
                      </label>
                      <v-autocomplete
                        @change="generateSelectedLoName"
                        :reduce="(option) => option.value"
                        :loading="CityCodeOptionsLoading"
                        :items="CityCodeOptions"
                        :rules="CityCodeRules"
                        v-model="CityCode"
                        dense
                        clearable
                        required
                        outlined
                        class="premium-input"
                        prepend-inner-icon="mdi-map-marker"
                        background-color="white"
                      ></v-autocomplete>
                    </div>
                  </v-col>

                  <!-- RIGHT COLUMN: TITLE DETAILS -->
                  <v-col cols="12" sm="12" md="6" class="location-right-col">
                    <div class="subsection-header">
                      <v-icon color="#10b981" class="subsection-icon">mdi-file-document-outline</v-icon>
                      <span class="subsection-title">Title Details</span>
                    </div>

                    <div class="form-group">
                      <label class="form-label">
                        <span class="required-mark">*</span>Signed LGB Resolution (PDF)
                      </label>
                      <div class="file-upload-wrapper">
                        <v-file-input
                          :clearable="false"
                          truncate-length="25"
                          accept="application/pdf"
                          placeholder="Click to upload PDF"
                          v-model="LGBResolution"
                          prepend-icon="mdi-file-pdf-box"
                          class="file-input-premium"
                          show-size
                          background-color="white"
                        >
                          <template v-slot:append-outer>
                            <v-icon 
                              v-if="LGBResolution && Object.keys(LGBResolution).length > 0"
                              color="#10b981" 
                              @click="LGBResolution = {}"
                              class="delete-btn"
                            >
                              mdi-close-circle
                            </v-icon>
                          </template>
                        </v-file-input>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>
                        Title Name Extension
                        <small
                          >(Please don’t enter JCI and City , it will be
                          automatically filled)</small
                        >
                      </h6>
                    </label>
                    <v-text-field
                      v-model="LomName"
                      :rules="LomNameRules"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <h6>Title Clearance Name</h6>
                    <p></p>
                    <h3>{{ SelectedLoName }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br /><br />

            <v-card elevation="8" class="payment-card premium-shadow">
              <div class="payment-header">
                <v-icon color="white" class="header-icon-payment">mdi-credit-card</v-icon>
                <h3 class="payment-title">Payment Details</h3>
              </div>
              <v-container class="payment-content-wrapper">
                <v-row wrap v-if="tableData1.length > 0">
                  <v-col align="center" cols="12" sm="12" md="12">
                    <!-- <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search records here"
                single-line
                hide-details
              ></v-text-field>-->
                    <br />
                    <v-data-table
                      class="elevation-1"
                      loading-text="Loading... Please wait"
                      disable-sort
                      disable-filtering
                      v-model="selected"
                      :search="search"
                      :loading="TableLoadingFlag"
                      :item-key="tableOptions1.ItemKey"
                      :single-select="tableOptions1.SingleSelectFlag"
                      :headers="tableColumns1"
                      :items="tableData1"
                      :items-per-page="tableOptions1.ItemsPerPage"
                      :footer-props="tableOptions1.FooterProps"
                      :hide-default-footer="tableOptions1.HideDefaultFooter"
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
                <br />
                <v-row>
                  <v-col align="center" cols="12" sm="12" md="12">
                    <h3 class="text-primary">
                      Total Amount : Rs. {{ tableOptions1.TotalAmountTxt }}
                    </h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br />
            <v-row wrap>
              <v-col align="center" cols="12" sm="12" md="12">
                <upload-progress
                  :ProgessStart="ProgessStart"
                  :UploadPercentage="uploadPercentage"
                ></upload-progress>
                <v-btn
                  :disabled="!valid"
                  type="submit"
                  color="success"
                  class="modern-submit-btn"
                  @click.prevent="confirmAlert"
                  :loading="SubmitFlag"
                >
                  <v-icon left>mdi-credit-card</v-icon>
                  Pay now
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      valid: true,
      LoadingFlag: false,
      SubmitFlag: false,
      ProgressLoadingFlag: false,
      StartupLoadingFlag: false,

      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      TableLoadingFlag: false,

      TotalAmount: 0,
      Member: {},

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      StateCodeRules: [(v) => !!v || "State is required"],
      StateCode: "",
      StateCodeOptions: [],
      StateCodeOptionsLoading: false,

      DistrictCodeRules: [(v) => !!v || "District is required"],
      DistrictCode: "",
      DistrictCodeOptions: [],
      DistrictCodeOptionsLoading: false,

      CityCodeRules: [(v) => !!v || "City is required"],
      CityCode: "",
      CityCodeOptions: [],
      CityCodeOptionsLoading: false,

      LomNameRules: [(v) => !!v || "New LO name is required"],
      LomName: "",
      SelectedLoName: "",

      ProgessStart: 0,
      uploadPercentage: 0,

      CurrentYearId: 0,

      ZoneCode: "",
      LomCode: "",
      YearCode: "",
      MonthCode: "",
      MonthName: "",

      LGBResolution: {},

      PageInfo: {},
      PageTitle: "Apply for New LO Title",
      PageDescription:
        "Complete the form to apply for a new LO title with member details and location information",
      JciYearCode: "",
      YearName: "",

      CartDetails: {},
      Order: {},
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.JciYearCode = tr.CurrentJciYearId;
        var YearName = tr.CurrentJciYearName;
        this.YearName = YearName;

        var MonthCode = this.$route.query.month;
        MonthCode = MonthCode == (null || undefined) ? 0 : MonthCode;
        console.log({ MonthCode });
        this.MonthCode = MonthCode;

        var tempDate1 = YearName + "-" + MonthCode + "-01";
        console.log({ tempDate1 });

        var tempDate2 = new Date(tempDate1);
        console.log({ tempDate2 });
        var MonthName = tempDate2.toLocaleString("en-us", { month: "long" });
        console.log({ MonthName });
        this.MonthName = MonthName;

        var ZoneCode = this.$session.get("ZoneId");
        ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
        console.log("ZoneCode=" + ZoneCode);
        this.ZoneCode = ZoneCode;

        var LomCode = this.$session.get("LomId");
        LomCode = LomCode == (null || undefined) ? "" : LomCode;
        console.log("LomCode=" + LomCode);
        this.LomCode = LomCode;

        this.pageData();
      }
    },
    CartDetails: function () {
      console.log("watch CartDetails");
      this.LoadingFlag = false;
      this.TableLoadingFlag = false;
      var tr = this.CartDetails;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var tableOptions = tr.TableOptions;
        this.tableOptions1 = tableOptions;
        this.tableColumns1 = tr.TableHeader;
        this.tableData1 = tr.TableData;
        this.TotalAmount = tableOptions.TotalAmount;
      }
    },
    StateCodeOptions: function () {
      console.log("watch StateCodeOptions");
      this.LoadingFlag = false;
      this.StateCodeOptionsLoading = false;
    },
    DistrictCodeOptions: function () {
      console.log("watch DistrictCodeOptions");
      this.LoadingFlag = false;
      this.DistrictCodeOptionsLoading = false;
    },
    CityCodeOptions: function () {
      console.log("watch CityCodeOptions");
      this.LoadingFlag = false;
      this.CityCodeOptionsLoading = false;
    },
    LomName: function () {
      console.log("watch LomName");
      this.generateSelectedLoName();
    },
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    refreshPageData() {
      console.log("refreshPageData called");

      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "provisional_lo",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);

      this.TableLoadingFlag = true;
      var url2 = "api/new-lom/cart-details";
      var condition2 = {
        UserInterface: 1,
      };
      this.getPageDetails("CartDetails", {}, url2, condition2);
    },
    pageData() {
      console.log("pageData called");
      this.getStateCodeOptions();
      this.getMemberDetails();
    },
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    resetForm() {
      this.$refs.form2.reset();
      this.tableData1 = [];
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    getStateCodeOptions() {
      console.log("getStateCodeOptions called");
      this.LoadingFlag = true;
      this.StateCodeOptionsLoading = true;
      var selectbox1_source = "StateCode";
      var selectbox1_destination = "StateCodeOptions";
      var selectbox1_url = "api/states/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getDistrictCodeOptions() {
      console.log("getDistrictCodeOptions called");
      var StateCode = this.StateCode;
      console.log({ StateCode });
      if (StateCode != "") {
        this.LoadingFlag = true;
        this.DistrictCodeOptionsLoading = true;
        var selectbox1_source = "DistrictCode";
        var selectbox1_destination = "DistrictCodeOptions";
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityCodeOptions() {
      console.log("getCityCodeOptions called");
      var DistrictCode = this.DistrictCode;
      console.log({ DistrictCode });
      if (DistrictCode != "") {
        this.CityCodeOptionsLoading = true;
        var selectbox1_source = "CityCode";
        var selectbox1_destination = "CityCodeOptions";
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getMemberDetails() {
      console.log("getMemberDetails is called");

      var MemberId = this.$session.get("MemberId");
      MemberId = MemberId == (null || undefined) ? "" : MemberId;

      console.log("MemberId=" + MemberId);

      if (MemberId != "") {
        this.StartupLoadingFlag = true;
        this.Member = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/show";
        var upload = {
          UserInterface: 1,
          MemberId: MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              var member = records[0];
              thisIns.Member = member;
              thisIns.MemberImageFlag = true;
              thisIns.Member.EmailId =
                member.EmailId == "NA" ? "" : member.EmailId;
              thisIns.Member.PrimaryMobile =
                member.PrimaryMobile == "NA" ? "" : member.PrimaryMobile;
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        this.toast("error", message);
      }
    },
    generateSelectedLoName() {
      console.log("generateSelectedLoName called");

      var CityCode = this.CityCode;
      var LomName = this.LomName;
      var SelectedLoName = "";

      if (CityCode != "") {
        var City = this.CityCodeOptions.find((data) => {
          return data.value == CityCode;
        });

        console.log("Selected City=" + JSON.stringify(City));

        SelectedLoName = "jci " + City.text + " " + LomName;
      } else {
        SelectedLoName = "jci {city name} " + LomName;
      }
      SelectedLoName = SelectedLoName.toUpperCase();
      console.log("SelectedLoName=" + SelectedLoName);

      this.SelectedLoName = SelectedLoName;
    },
    confirmAlert() {
      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var TotalAmount = this.TotalAmount;
      console.log({ TotalAmount });

      var TotalAmountTxt = this.tableOptions1.TotalAmountTxt;
      console.log({ TotalAmountTxt });

      var Member = this.Member;
      console.log({ Member });

      var MemberId = Member.MemberId;
      console.log({ MemberId });

      // TotalAmount = 0;

      if (validate1 && TotalAmount > 0 && MemberId != "") {
        var htmlTxt = "";
        // htmlTxt += "<b>Please verify all the information before proceeding</b>";
        htmlTxt += "<b>Selected New LO details</b>";
        htmlTxt += "<br/><br/>";
        htmlTxt += "LO Name <b>" + this.SelectedLoName + "</b><br/>";
        htmlTxt += "Amount. <b>" + TotalAmountTxt + "</b><br/>";
        htmlTxt += "<br/><br/>";
        htmlTxt += "Do you want to continue?";
        Swal.fire({
          title: "Please verify all the information before proceeding",
          text: "",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalAmount == 0) {
          message += "Payment details invalid. ";
        }
        if (MemberId == 0) {
          message += "President details invaid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      this.ProgressLoadingFlag = true;
      this.SubmitFlag = true;

      var Member = this.Member;
      console.log({ Member });

      var MemberId = Member.MemberId;
      console.log({ MemberId });

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/new-lom-title/order-create";

      let upload = new FormData();
      upload.append("UserInterface", 1);
      upload.append("LomCode", this.LomCode);
      upload.append("MobileNo", Member.PrimaryMobile);
      upload.append("EmailId", Member.EmailId);
      upload.append("NewLomName", this.SelectedLoName);
      upload.append("State", this.StateCode);
      upload.append("City", this.CityCode);
      upload.append("TotalAmount", this.TotalAmount);
      upload.append("LGBResolution", this.LGBResolution);
      upload.append("MemberId", MemberId);
      upload.append("SponsorType", "2"); // 1=LO, 2=Member
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ProgressLoadingFlag = false;
          thisIns.SubmitFlag = false;

          flag = response.data.flag;
          console.log({ flag });

          output = response.data.output;
          console.log({ output });

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.toast("success", output);
            thisIns.Order = records.Order;
            thisIns.makePayment();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
          thisIns.ProgressLoadingFlag = false;
          console.log({ error });
          thisIns.toast("error", output);
        });
    },
    makePayment() {
      console.log("makePayment");
      // ev.preventDefault();
      var order = this.Order;
      const thisIns = this;
      var rzp1 = new Razorpay({
        key: order.rzp_key,
        account_id: order.rzp_account_id,
        order_id: order.rzp_order_id,
        amount: order.rzp_amount,
        name: order.rzp_name,
        currency: "INR",
        description: order.rzp_description,
        image: order.rzp_image,
        theme: {
          color: order.rzp_color,
        },
        prefill: {
          name: order.customer_name,
          email: order.customer_email_id,
          contact: order.customer_mobile_no,
        },
        notes: {
          address: "",
        },
        // callback_url: "http://domain.com/#/about/" + this.order_id,
        redirect: false,
        handler: function (response) {
          console.log("razorpay_payment_id=" + response.razorpay_payment_id);
          thisIns.ProgressLoadingFlag = true;
          thisIns.SubmitFlag = true;
          // thisIns.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
          thisIns.pageRedirect({}, "/order/success");
        },
      });
      rzp1.open();
    },
    formatDate(dateStr) {
      if (!dateStr) return "N/A";
      try {
        const options = { year: "numeric", month: "short", day: "numeric" };
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-US", options);
      } catch (error) {
        return dateStr;
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// Premium Color Palette
$primary-navy: #001a4d;
$secondary-navy: #003d7a;
$tertiary-cyan: #0099cc;
$success-color: #10b981;
$gradient-main: linear-gradient(135deg, $secondary-navy 0%, $tertiary-cyan 100%);

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

#new-lo-title-create {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  min-height: 100vh;
  padding: 24px 0;
  animation: fadeIn 0.6s ease-in-out;

  // PREMIUM HEADER
  .premium-header-card {
    background: $gradient-main !important;
    border-radius: 16px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(0, 26, 77, 0.3);
    margin: 24px;

    .header-gradient-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $gradient-main;
    }

    .header-backdrop-effect {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 1px,
        transparent 1px
      );
      background-size: 50px 50px;
      animation: rotate 20s linear infinite;
    }
  }

  .header-content-premium {
    position: relative;
    z-index: 1;
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 50%;
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    animation: float 3s ease-in-out infinite;
  }

  .header-title {
    font-size: 32px;
    font-weight: 800;
    letter-spacing: 0.5px;
    margin: 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    animation: slideInLeft 0.6s ease-out 0.1s both;
  }

  .header-subtitle {
    font-size: 16px;
    opacity: 0.9;
    margin: 4px 0 0 0;
    animation: fadeInUp 0.8s ease-out 0.2s both;
  }

  .premium-action-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    background: rgba(255, 255, 255, 0.2) !important;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50% !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
    margin: 0 4px;

    &:hover {
      transform: translateY(-4px) scale(1.1);
      background: rgba(255, 255, 255, 0.3) !important;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: translateY(-2px);
    }
  }

  // MAIN CARD
  .main-card {
    border-radius: 14px !important;
    box-shadow: 0 12px 40px rgba(0, 26, 77, 0.12) !important;
    animation: fadeInUp 0.6s ease-out 0.2s both;
    margin: 0 24px 24px 24px;
  }

  // CONTENT SECTION
  .content-section {
    padding: 32px !important;
    background: linear-gradient(135deg, #fafbfc 0%, #ffffff 100%);
  }

  // MEMBER CARD
  .member-card {
    border-radius: 12px !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid #e3f2fd;
    animation: slideInLeft 0.5s ease-out 0.2s both;
    transition: all 0.3s ease;
    background: white !important;

    &:hover {
      box-shadow: 0 8px 24px rgba(25, 118, 210, 0.12) !important;
      transform: translateY(-2px);
    }
  }

  .profile-section {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 24px;
    padding: 24px;
    background: linear-gradient(
      135deg,
      rgba(25, 118, 210, 0.04) 0%,
      rgba(119, 235, 255, 0.02) 100%
    );
    border-radius: 12px;
    animation: fadeInUp 0.6s ease-out 0.3s both;
  }

  .profile-image {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 3px solid #e3f2fd;
    width: 80px;
    height: 80px;
    object-fit: cover;
    animation: fadeIn 0.6s ease-out 0.4s both;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 16px rgba(25, 118, 210, 0.2);
    }
  }

  .section-title {
    font-size: 14px;
    font-weight: 800;
    color: white;
    background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
    padding: 10px 16px;
    border-radius: 6px;
    margin-bottom: 16px;
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    animation: slideDown 0.4s ease-out both;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
  }

  .info-row {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    font-size: 13px;
    line-height: 1.6;
    animation: fadeInUp 0.4s ease-out both;
    padding: 8px;
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(25, 118, 210, 0.04);
    }

    &:nth-child(1) {
      animation-delay: 0.1s;
    }
    &:nth-child(2) {
      animation-delay: 0.15s;
    }
    &:nth-child(3) {
      animation-delay: 0.2s;
    }
    &:nth-child(4) {
      animation-delay: 0.25s;
    }
    &:nth-child(5) {
      animation-delay: 0.3s;
    }
    &:nth-child(n + 6) {
      animation-delay: 0.35s;
    }
  }

  .info-label {
    font-weight: 700;
    color: #1976d2;
    min-width: 110px;
    display: inline-block;
  }

  .info-value {
    color: #1a237e;
    flex: 1;
    font-weight: 600;
    word-break: break-word;
  }

  .member-name {
    font-size: 18px;
    font-weight: 800;
    margin-top: 8px;
    color: #1a237e;
  }

  .member-id {
    font-size: 12px;
    margin-top: 4px;
    color: #999;
    font-weight: 600;
  }

  // DATA TABLE
  ::v-deep .v-data-table {
    background: white !important;
    border-radius: 12px;
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out 0.3s both;
    box-shadow: 0 8px 24px rgba(0, 26, 77, 0.1) !important;

    .v-data-table__wrapper {
      border-radius: 12px;

      table {
        thead tr {
          background: $gradient-main !important;
          animation: slideDown 0.6s ease-out;

          th {
            color: white !important;
            font-weight: 800 !important;
            font-size: 14px !important;
            padding: 16px 12px !important;
            border: none !important;
            letter-spacing: 0.3px;
            text-transform: uppercase;
          }
        }

        tbody tr {
          transition: all 0.3s ease !important;
          border-bottom: 1px solid #e8ecf1 !important;

          &:nth-child(odd) {
            background-color: #f9fafb;
          }

          &:hover {
            background: linear-gradient(
              90deg,
              #e3f2fd 0%,
              #f3e5f5 100%
            ) !important;
            transform: scale(1.001);
            box-shadow: inset 0 2px 8px rgba(25, 118, 210, 0.1);
          }

          td {
            padding: 14px 12px !important;
            font-size: 13px !important;
            color: #333;
            font-weight: 500;
          }
        }
      }
    }
  }

  // SUBMIT BUTTON
  .modern-submit-btn {
    border-radius: 10px !important;
    font-weight: 800 !important;
    padding: 14px 32px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: linear-gradient(
      135deg,
      $success-color 0%,
      #059669 100%
    ) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3) !important;
    color: white !important;
    font-size: 13px;

    .v-icon {
      margin-right: 8px;
    }

    &:hover:not(:disabled) {
      transform: translateY(-4px);
      box-shadow: 0 12px 32px rgba(16, 185, 129, 0.4) !important;
    }

    &:active:not(:disabled) {
      transform: translateY(-2px);
    }

    &:disabled {
      opacity: 0.6;
    }
  }

  // UTILITY CLASSES
  .mb-6 {
    margin-bottom: 24px;
  }

  .pa-8 {
    padding: 32px;
  }

  .d-flex {
    display: flex;
  }

  .overflow-hidden {
    overflow: hidden;
  }

  .white--text {
    color: white;
  }

  .v-progress-circular {
    animation: pulse 1s infinite;
  }

  // LOCATION CARD
  .location-card {
    border-radius: 12px !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid #e3f2fd;
    animation: slideInLeft 0.5s ease-out 0.2s both;
    transition: all 0.3s ease;
    background: white !important;
    overflow: hidden;

    &:hover {
      box-shadow: 0 8px 24px rgba(25, 118, 210, 0.12) !important;
      transform: translateY(-2px);
    }
  }

  .location-header {
    display: flex;
    align-items: center;
    gap: 16px;
    background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
    padding: 16px 24px;
    color: white;
    animation: slideDown 0.5s ease-out;

    .header-icon-location {
      font-size: 28px !important;
    }

    .location-title {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.3px;
      text-transform: uppercase;
    }
  }

  // PAYMENT CARD
  .payment-card {
    border-radius: 12px !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid #e8f5e9;
    animation: slideInLeft 0.5s ease-out 0.3s both;
    transition: all 0.3s ease;
    background: white !important;
    overflow: hidden;

    &:hover {
      box-shadow: 0 8px 24px rgba(16, 185, 129, 0.15) !important;
      transform: translateY(-2px);
    }
  }

  .payment-header {
    display: flex;
    align-items: center;
    gap: 16px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    padding: 16px 24px;
    color: white;
    animation: slideDown 0.5s ease-out 0.1s both;

    .header-icon-payment {
      font-size: 28px !important;
    }

    .payment-title {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.3px;
      text-transform: uppercase;
    }
  }

  // PREMIUM FORM INPUTS
  .premium-input {
    margin-bottom: 8px !important;
    animation: fadeInUp 0.4s ease-out both;

    ::v-deep .v-input__control {
      .v-input__slot {
        border-radius: 8px;
        transition: all 0.3s ease;

        fieldset {
          border-color: #e3f2fd !important;
          border-width: 1px !important;
        }
      }

      &:hover {
        .v-input__slot fieldset {
          border-color: #1976d2 !important;
          border-width: 2px !important;
        }
      }
    }
  }

  .form-row {
    margin-bottom: 4px !important;
    padding: 0 !important;
  }

  // FINAL TITLE BOX
  .final-title-box {
    background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
    border-left: 4px solid #10b981;
    padding: 14px 16px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    color: #2e7d32;
    animation: slideInLeft 0.5s ease-out;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
    min-height: 44px;
    display: flex;
    align-items: center;
  }

  .mt-4 {
    margin-top: 16px !important;
  }

  .mb-2 {
    margin-bottom: 8px !important;
  }

  // LOCATION SECTION PREMIUM STYLES
  .location-content-wrapper {
    padding: 28px !important;
    background: linear-gradient(135deg, #fafbfc 0%, #ffffff 100%);
  }

  .location-grid {
    gap: 24px !important;
  }

  .location-left-col,
  .location-right-col {
    animation: fadeInUp 0.5s ease-out both;
  }

  .location-right-col {
    animation-delay: 0.1s;
  }

  .subsection-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e3f2fd;

    .subsection-icon {
      font-size: 24px !important;
    }

    .subsection-title {
      font-size: 16px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #1a237e;
    }
  }

  .location-right-col .subsection-header {
    border-bottom-color: #e8f5e9;
  }

  .form-group {
    margin-bottom: 22px;
    animation: fadeInUp 0.4s ease-out both;

    &:nth-child(1) {
      animation-delay: 0.1s;
    }
    &:nth-child(2) {
      animation-delay: 0.15s;
    }
    &:nth-child(3) {
      animation-delay: 0.2s;
    }
    &:nth-child(4) {
      animation-delay: 0.25s;
    }
  }

  .form-label {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: #1a237e;
    margin-bottom: 10px;
    letter-spacing: 0.3px;
    text-transform: uppercase;

    .required-mark {
      color: #e53935;
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .form-hint {
    display: block;
    font-size: 12px;
    color: #666;
    font-weight: 500;
    margin-top: 4px;
    text-transform: none;
    letter-spacing: normal;
  }

  .file-upload-wrapper {
    position: relative;
    animation: slideInLeft 0.5s ease-out;
  }

  .file-input-premium {
    ::v-deep .v-input__control {
      .v-input__slot {
        border-radius: 8px !important;
        background-color: white !important;
        transition: all 0.3s ease !important;

        fieldset {
          border-color: #e3f2fd !important;
          border-width: 1px !important;
        }
      }

      &:hover {
        .v-input__slot fieldset {
          border-color: #10b981 !important;
          border-width: 2px !important;
        }
      }
    }
  }

  .delete-btn {
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  // FINAL TITLE BOX PREMIUM
  .final-title-box-premium {
    background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
    border-left: 4px solid #10b981;
    border-radius: 8px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    gap: 12px;
    animation: slideInLeft 0.5s ease-out;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
    min-height: 48px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
      transform: translateX(2px);
    }

    .final-icon {
      font-size: 22px !important;
      flex-shrink: 0;
    }

    .final-title-text {
      color: #2e7d32;
      font-size: 14px;
      font-weight: 700;
      word-break: break-word;
      letter-spacing: 0.2px;
    }
  }

  .premium-shadow {
    box-shadow: 0 12px 40px rgba(0, 26, 77, 0.15) !important;
    border: none !important;
    overflow: hidden;
  }

  // PAYMENT SECTION PREMIUM STYLES
  .payment-content-wrapper {
    padding: 28px !important;
    background: linear-gradient(135deg, #fafbfc 0%, #ffffff 100%);
  }
}
</style>